import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '@wfp-root-app/store/store';
import _, { startCase } from 'lodash';

import FiltersComponent from '../utils/filters';
import { Filter, MultiSelectFilter } from '../utils/FilterTypes';
import State from '../app/store/state';
import { UserStatuses } from '../utils/users';
import { ActionCreators } from './partnersActions';
import { SORT_OPTIONS } from '../utils/hooks/useSort';

interface Props {
    sortOptions: SORT_OPTIONS;
}

const PartnerFilters: React.FC<Props> = ({ sortOptions }) => {
    const [activeFilters, setActiveFilters] = useState<Filter[]>([]);
    const dispatch = useAppDispatch();
    const partnerStatuses = useSelector((state: State) => state.appConfig.userStatuses.partnerStatus);

    useEffect(() => {
        const statusesOptions = Object.values(partnerStatuses).map((status: UserStatuses) => ({
            label: startCase(status),
            value: status,
        }));

        setActiveFilters([
            new MultiSelectFilter(
                'Status',
                'status',
                [
                    { label: startCase(UserStatuses.active), value: UserStatuses.active },
                    { label: startCase(UserStatuses.parked), value: UserStatuses.parked },
                ],
                statusesOptions,
                null,
                true
            ),
        ]);
    }, []);

    useEffect(() => {
        if (activeFilters.length > 0) {
            fetchPartners();
        }
    }, [activeFilters, sortOptions]);

    const fetchPartners = () => {
        dispatch(
            ActionCreators.loadPartners(
                sortOptions,
                activeFilters.filter((input) => input.isSelected)
            )
        );
    };

    const filterChangedHandler = (filter: Filter) => {
        const activeFiltersCopy = _.clone(activeFilters);
        const index = activeFiltersCopy.findIndex((x) => x.name === filter.name);

        if (index === -1) {
            setActiveFilters(activeFiltersCopy.concat([filter]));
        } else {
            activeFiltersCopy.splice(index, 1, filter);
            setActiveFilters(activeFiltersCopy);
        }
    };

    return (
        <FiltersComponent
            defaultFilters={activeFilters}
            filters={activeFilters}
            onFilterChanged={filterChangedHandler}
            withApply={false}
            withIsSelected={false}
        />
    );
};

PartnerFilters.displayName = 'PartnerFilters';

export { PartnerFilters };
